import React from 'react';
import PropTypes from 'prop-types';
import AccountDropDown from './filter/AccountDropDown';
import { LargeBody } from 'web-ui-components/lib/typography/body';

const PaymentAccountDropDown = ({
  label,
  selectedAccountId,
  accountList,
  onChangeAccount,
}) => {
  return (
    <div className="c-field">
      <LargeBody id="dropdown-account-select-menu"> {label}</LargeBody>
      <div className="c-field__controls">
        <AccountDropDown
          selectedAccountId={selectedAccountId}
          hasAll
          accountList={accountList}
          onDropdownSelect={onChangeAccount}
        />
      </div>
    </div>
  );
};

PaymentAccountDropDown.propTypes = {
  label: PropTypes.string.isRequired,
  selectedAccountId: PropTypes.string.isRequired,
  accountList: PropTypes.array.isRequired,
  onChangeAccount: PropTypes.func.isRequired,
};

export default PaymentAccountDropDown;
